import {loadAllPages} from './nb-store-search.js?v=20260914';
import {initialState,transition,locateStores,directionsURL} from './nb-store-geo.js?v=20260914-maps2';
import {StoreMap} from './nb-store-map.js?v=20260914-maps2';

const PAGE_SIZE=10;
// First and last page stay reachable; the rest collapses around the current one.
const pageTokens=(page,pages,isMobile=false)=>{
 if(isMobile){
  if(pages<=4)return Array.from({length:pages},(_,index)=>index+1);
  if(page<=2||page>=pages-1)return [1,2,'gap',pages-1,pages];
  if(page===3)return pages===5?[1,2,3,4,5]:[1,2,3,'gap',pages];
  if(page===pages-2)return [1,'gap',pages-2,pages-1,pages];
  return [1,'gap',page,'gap',pages];
 }
 if(pages<=7)return Array.from({length:pages},(_,index)=>index+1);
 const around=[page-1,page,page+1].filter(number=>number>1&&number<pages);
 const tokens=[1];
 if(around[0]>2)tokens.push('gap');
 tokens.push(...around);
 if(around.at(-1)<pages-1)tokens.push('gap');
 tokens.push(pages);
 return tokens;
};

if(!customElements.get('nb-store-locator'))customElements.define('nb-store-locator',class extends HTMLElement{
 $(name){return this.querySelector(`[data-${name}]`);}
 connectedCallback(){
  this.disconnectedCallback();this.abort=new AbortController();this.generation=(this.generation||0)+1;
  this.form=this.querySelector('form');this.input=this.form.elements.query;this.labels=JSON.parse(this.$('map-labels').textContent);
  this.state=initialState(this.dataset.radius);this.sequence=0;this.mapFailed=false;this.ready=false;this.mapLoading=false;
  const opts={signal:this.abort.signal},on=(el,event,fn)=>el.addEventListener(event,fn,opts);
  on(this.form,'submit',e=>{
   e.preventDefault();
   if(this.mapFailed){this.render();this.$('directory')?.scrollIntoView({behavior:this.scrollBehavior(),block:'start'});}
   else if(this.state.pending&&this.predictions?.length){this.choose(0);}
   else if(this.state.pending){this.message(this.labels.selectAddress);}
   else{this.render();this.$('directory')?.scrollIntoView({behavior:this.scrollBehavior(),block:'start'});}
  });
  on(this.input,'input',()=>this.inputChanged());on(this.input,'keydown',e=>this.keydown(e));
  on(this.input,'blur',()=>{clearTimeout(this.typingTimer);this.sequence++;this.blurTimer=setTimeout(()=>this.closeSuggestions(),150);});
  if(this.form.elements.province)on(this.form.elements.province,'change',e=>this.change({type:'province',value:e.target.value}));
  on(this.form.elements.formula,'change',e=>{this.formulaURL(e.target.value);this.change({type:'formula',value:e.target.value});});
  on(this.form,'reset',e=>{e.preventDefault();this.change({type:'reset'});this.formulaURL('');});
  on(this.$('expand'),'click',()=>this.change({type:'expand'}));
  on(this.$('retry-map'),'click',()=>this.initMap());on(this.$('retry-data'),'click',()=>this.load());
  on(window,'nb:maps-error',()=>this.mapError());on(window,'pageshow',()=>this.revalidate());
  const mql=typeof matchMedia==='function'?matchMedia('(max-width: 768px)'):null;
  if(mql?.addEventListener)on(mql,'change',()=>{
   if(this.matches){
    const size=this.pageSize(),pages=Math.max(1,Math.ceil(this.matches.located.length/size));
    this.renderPagination(pages);
   }
  });
  this.bindProvincePills();
  this.validityTimer=setInterval(()=>this.revalidate(),60000);this.load();this.initMap();
 }
 disconnectedCallback(){
  this.abort?.abort();this.map?.destroy();this.map=null;clearTimeout(this.typingTimer);clearTimeout(this.blurTimer);clearInterval(this.validityTimer);
  this.sequence=(this.sequence||0)+1;this.generation=(this.generation||0)+1;
 }
 message(text){const el=this.$('search-message');if(el)el.textContent=text||'';}
 formulaURL(value){const url=new URL(location.href);value?url.searchParams.set('formula',value):url.searchParams.delete('formula');history.replaceState(null,'',url);}
 provinceName(code){return this.labels.provinces[code]||code;}
 scrollBehavior(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';}
 async load(){
  const generation=this.generation;this.$('status').textContent=this.dataset.loading;this.$('retry-data').hidden=true;this.$('directory').setAttribute('aria-busy','true');
  try{
   const stores=await loadAllPages(new URL(this.dataset.source,location.href).href,url=>fetch(url,{signal:this.abort.signal}));
   if(generation!==this.generation||!this.isConnected)return;
   this.stores=stores;const select=this.form.elements.province;select.replaceChildren(select.options[0]);
   const provinces=[...new Set(stores.map(s=>s.province))].sort();for(const code of provinces)select.add(new Option(this.provinceName(code),code));
   const formula=new URL(location.href).searchParams.get('formula');
   if(!this.loadedOnce&&[...this.form.elements.formula.options].some(o=>o.value===formula))this.state.formula=formula;this.loadedOnce=true;
   const pillsList=this.querySelector('[data-province-pills-list]');
   if(pillsList){
    const allLabel=this.form.elements.province?.options[0]?.textContent||'All provinces';
    const allBtn=document.createElement('button');allBtn.type='button';allBtn.className=`nb-province-pill${this.state.province?'':' is-active'}`;allBtn.dataset.provinceCode='';allBtn.textContent=allLabel;
    allBtn.addEventListener('click',()=>{if(this.form?.elements?.province)this.form.elements.province.value='';this.change({type:'province',value:''});},{signal:this.abort.signal});
    const buttons=[allBtn];
    for(const code of provinces){
     const btn=document.createElement('button');btn.type='button';btn.className=`nb-province-pill${this.state.province===code?' is-active':''}`;btn.dataset.provinceCode=code;btn.textContent=code;
     btn.addEventListener('click',()=>{if(this.form?.elements?.province)this.form.elements.province.value=code;this.change({type:'province',value:code});},{signal:this.abort.signal});
     buttons.push(btn);
    }
    pillsList.replaceChildren(...buttons);
   }
   this.$('coverage').replaceChildren(...provinces.map(code=>{
    const button=document.createElement('button');button.type='button';button.textContent=`${this.provinceName(code)} · ${stores.filter(s=>s.province===code).length}`;
    button.addEventListener('click',()=>{this.change({type:'province',value:code});this.$('map-panel').scrollIntoView({block:'start',behavior:this.scrollBehavior()});},{signal:this.abort.signal});return button;
   }));this.syncInputs();this.render();
  }catch(error){if(generation===this.generation&&error.name!=='AbortError'){this.$('status').textContent=this.dataset.error;this.$('retry-data').hidden=false;}}
  finally{if(generation===this.generation)this.$('directory').setAttribute('aria-busy','false');}
 }
 bindProvincePills(){
  const pills=this.querySelectorAll('[data-province-code]');
  for(const pill of pills){
   pill.addEventListener('click',()=>{
    const code=pill.dataset.provinceCode||'';
    if(this.form?.elements?.province)this.form.elements.province.value=code;
    this.change({type:'province',value:code});
   },{signal:this.abort.signal});
  }
 }
 async initMap(){
  if(this.mapLoading)return;this.mapLoading=true;const generation=this.generation;
  this.$('map-message').textContent=this.labels.mapLoading;this.$('retry-map').hidden=true;
  try{
   if(!this.dataset.mapId)throw Error('missing_map_id');
   const map=await StoreMap.create(this.$('map'),{key:this.dataset.mapKey,mapId:this.dataset.mapId,language:document.documentElement.lang.startsWith('fr')?'fr':'en',labels:this.labels,onSelect:(id,fromCard)=>this.highlight(id,fromCard)});
   if(generation!==this.generation||!this.isConnected){map.destroy();return;}
   this.map=map;this.ready=true;this.mapFailed=false;this.$('map-message').textContent='';if(this.$('fallback-submit'))this.$('fallback-submit').hidden=true;
   this.message('');this.render();if(this.state.text.trim()&&!this.state.origin)this.inputChanged();
  }catch{if(generation===this.generation)this.mapError();}finally{if(generation===this.generation)this.mapLoading=false;}
 }
 mapError(){
  this.ready=false;this.mapFailed=true;this.sequence++;this.closeSuggestions();this.map?.destroy();this.map=null;
  this.state={...this.state,origin:null,pending:false,selected:null};this.$('map-message').textContent=this.labels.mapError;
  this.$('retry-map').hidden=false;if(this.$('fallback-submit'))this.$('fallback-submit').hidden=false;this.message('');this.render(false);
 }
 change(action){
  if(['province','reset'].includes(action.type)){this.sequence++;clearTimeout(this.typingTimer);this.closeSuggestions();this.map?.resetSession();}
  this.state=transition(this.state,action);this.syncInputs();this.message(this.state.pending?this.labels.selectAddress:'');this.render();
 }
 syncInputs(){
  this.input.value=this.state.text;
  if(this.form.elements.province)this.form.elements.province.value=this.state.province;
  this.form.elements.formula.value=this.state.formula;
  this.querySelectorAll('[data-province-code]').forEach(pill=>{
   pill.classList.toggle('is-active',(pill.dataset.provinceCode||'')===(this.state.province||''));
   pill.setAttribute('aria-pressed',String((pill.dataset.provinceCode||'')===(this.state.province||'')));
  });
 }
 revalidate(){
  if(!this.stores||!this.matches)return;
  const next=locateStores(this.stores,this.state,{fallback:this.mapFailed});
  if(next.located.map(s=>s.id).join(',')!==this.matches.located.map(s=>s.id).join(','))this.render(false);
 }
 inputChanged(){
  const sequence=++this.sequence;clearTimeout(this.typingTimer);this.closeSuggestions();this.predictions=[];this.state=transition(this.state,{type:'input',value:this.input.value});
  this.syncInputs();this.render();
  if(this.mapFailed){this.message('');return;}
  if(!this.state.pending){this.map?.resetSession();this.message('');return;}
  this.message(this.labels.selectAddress);if(!this.ready||this.input.value.trim().length<3)return;
  this.typingTimer=setTimeout(async()=>{
   try{
    const predictions=await this.map.suggest(this.input.value.trim());if(sequence!==this.sequence||!this.isConnected)return;
    this.predictions=predictions;this.activeSuggestion=-1;const list=this.$('suggestions');
    list.replaceChildren(...predictions.map((prediction,index)=>{
     const item=document.createElement('li');item.id=`${list.id}-${index}`;item.setAttribute('role','option');item.setAttribute('aria-selected','false');item.textContent=prediction.text.toString();
     item.addEventListener('pointerdown',e=>e.preventDefault());item.addEventListener('click',()=>this.choose(index));return item;
    }));this.$('suggestions-panel').hidden=!predictions.length;this.input.setAttribute('aria-expanded',String(Boolean(predictions.length)));
    if(!predictions.length)this.message(this.labels.noSuggestions);
   }catch{if(sequence===this.sequence)this.mapError();}
  },300);
 }
 closeSuggestions(){this.$('suggestions-panel')?.setAttribute('hidden','');this.input?.setAttribute('aria-expanded','false');this.input?.removeAttribute('aria-activedescendant');this.activeSuggestion=-1;}
 keydown(event){
  const open=!this.$('suggestions-panel').hidden;
  if(event.key==='Escape'){this.sequence++;clearTimeout(this.typingTimer);this.closeSuggestions();return;}
  if(open&&['ArrowDown','ArrowUp'].includes(event.key)){
   event.preventDefault();const count=this.predictions.length;this.activeSuggestion=(this.activeSuggestion+(event.key==='ArrowDown'?1:-1)+count)%count;
   [...this.$('suggestions').children].forEach((item,index)=>item.setAttribute('aria-selected',String(index===this.activeSuggestion)));
   this.input.setAttribute('aria-activedescendant',`${this.$('suggestions').id}-${this.activeSuggestion}`);
  }else if(open&&event.key==='Enter'&&this.activeSuggestion>=0){event.preventDefault();this.choose(this.activeSuggestion);}
 }
 async choose(index){
  const prediction=this.predictions[index];if(!prediction||!this.map)return;const sequence=++this.sequence;this.closeSuggestions();this.message(this.labels.resolving);
  try{const origin=await this.map.resolve(prediction);if(sequence!==this.sequence||!this.isConnected)return;
   this.state=transition(this.state,{type:'origin',origin,text:prediction.text.toString()});this.syncInputs();this.message(this.labels.distanceNote);this.render();
  }catch{if(sequence===this.sequence)this.message(this.labels.addressError);}
 }
 render(reframe=true){
  if(!this.stores||!this.isConnected)return;
  const matches=locateStores(this.stores,this.state,{fallback:this.mapFailed});this.matches=matches;
  const proximity=Boolean(this.state.origin),count=matches.located.length+(proximity?0:matches.unlocated.length);
  this.$('status').textContent=proximity?this.labels.nearResults.replace('[count]',count).replace('[radius]',this.state.radius):count===1?this.dataset.result:count?this.dataset.results.replace('[count]',count):this.dataset.empty;
  const signature=matches.located.map(s=>s.id).join(',');
  if(signature!==this.pageSignature){this.pageSignature=signature;this.page=1;}
  this.renderPage(matches.located);this.$('unlocated-results').replaceChildren(...matches.unlocated.map(s=>this.card(s)));
  this.$('unlocated').hidden=!matches.unlocated.length;this.$('unlocated-summary').textContent=this.labels.unlocated.replace('[count]',matches.unlocated.length);
  this.$('incomplete').hidden=!proximity||!matches.unlocated.length;this.$('incomplete').textContent=this.labels.incomplete.replace('[count]',matches.unlocated.length);
  const expand=this.$('expand');expand.hidden=!proximity||matches.located.length>0||this.state.radius>=200;expand.textContent=this.labels.expand.replace('[radius]',this.state.radius<100?100:200);
  this.$('browse-provinces').hidden=!proximity||matches.located.length>0;this.map?.update(matches.located,this.state,reframe);
 }
 pageSize(){const size=Number(this.dataset.pageSize);return Number.isFinite(size)&&size>0?Math.floor(size):PAGE_SIZE;}
 renderPage(located){
  const size=this.pageSize(),pages=Math.max(1,Math.ceil(located.length/size));
  this.page=Math.min(Math.max(this.page||1,1),pages);
  const start=(this.page-1)*size;
  this.$('results').replaceChildren(...located.slice(start,start+size).map(s=>this.card(s)));
  this.renderPagination(pages);
 }
 renderPagination(pages){
  const nav=this.$('pagination');if(!nav)return;
  nav.hidden=pages<2;
  const list=this.$('pagination-list');if(!list)return;
  if(pages<2){list.replaceChildren();return;}
  const isMobile=typeof matchMedia==='function'&&matchMedia('(max-width: 768px)').matches;
  const items=[this.pageButton(this.labels.previousPage,this.page-1,this.page<2)];
  for(const token of pageTokens(this.page,pages,isMobile)){
   if(token==='gap'){const gap=document.createElement('span');gap.className='nb-page-gap';gap.setAttribute('aria-hidden','true');gap.textContent='…';items.push(gap);continue;}
   items.push(this.pageButton(String(token),token,false,token===this.page));
  }
  items.push(this.pageButton(this.labels.nextPage,this.page+1,this.page>=pages));
  list.replaceChildren(...items);
 }
 pageButton(text,target,disabled,current=false){
  const button=document.createElement('button');button.type='button';button.textContent=text;
  button.className=`nb-page-pill${current?' is-active':''}`;button.disabled=disabled;
  if(current)button.setAttribute('aria-current','page');
  if(!disabled&&!current)button.addEventListener('click',()=>this.goToPage(target),{signal:this.abort.signal});
  return button;
 }
 goToPage(target){
  if(!this.matches)return;
  this.page=target;this.renderPage(this.matches.located);
  // Moving focus to the top of the new page reports the change without a live region.
  const first=this.$('results')?.firstElementChild;
  if(first){first.scrollIntoView({behavior:this.scrollBehavior(),block:'start'});first.focus({preventScroll:true});}
 }
 card(store){
  const article=document.createElement('article');article.className='nb-store-card';article.dataset.storeId=store.id;article.tabIndex=-1;
  const name=document.createElement('h2');name.textContent=store.name;const address=document.createElement('p');address.textContent=`${store.address}, ${store.city}, ${store.province} ${store.postal_code}`;article.append(name,address);
  if(store.distance!=null){const distance=document.createElement('p');distance.className='nb-store-distance';distance.textContent=this.labels.distance.replace('[distance]',new Intl.NumberFormat(document.documentElement.lang,{maximumFractionDigits:1}).format(store.distance));article.append(distance);}
  for(const text of [store.aisle,store.note])if(text){const p=document.createElement('p');p.textContent=text;article.append(p);}
  const formulas=document.createElement('div');formulas.className='nb-store-formulas';
  for(const key of store.formulas||[]){const label=[...this.form.elements.formula.options].find(o=>o.value===key)?.textContent;if(label){const pill=document.createElement('span');pill.textContent=label;formulas.append(pill);}}article.append(formulas);
  const link=document.createElement('a');link.href=directionsURL(store);link.textContent=this.dataset.directions;link.target='_blank';link.rel='noopener';article.append(link);
  if(store.position&&this.ready){const button=document.createElement('button');button.type='button';button.className='nb-view-map';button.textContent=this.labels.viewMap;button.addEventListener('click',()=>{this.map?.select(store.id);this.$('map-panel').scrollIntoView({block:'start',behavior:this.scrollBehavior()});});article.append(button);}return article;
 }
 highlight(id,fromCard){
  this.state=transition(this.state,{type:'select',id});
  // A pin can belong to a page that is not on screen; bring that page up first.
  const located=this.matches?.located||[],index=located.findIndex(s=>String(s.id)===String(id));
  if(index>=0){const page=Math.floor(index/this.pageSize())+1;if(page!==this.page){this.page=page;this.renderPage(located);}}
  for(const card of this.$('results').children){const selected=card.dataset.storeId===String(id);card.classList.toggle('is-selected',selected);if(selected&&!fromCard){card.scrollIntoView({block:'nearest',behavior:this.scrollBehavior()});card.focus({preventScroll:true});}}
 }
});
